import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class CurrentTitleService {
  private currentTitleKey: string | null = null;

  setTitleWithKey(key: string) {
    this.currentTitleKey = key;
  }

  getCurrentTitleKey(): string | null {
    return this.currentTitleKey;
  }
}
